var pairs = [
    {
        name: "SGB/CAND",
        address: "0x32c16bA8A4B1f2501A16bcdAF53b51Fb982eAec4",
        tokenA: "0x02f0826ef6aD107Cfc861152B32B52fD11BaB9ED",
        tokenB: "0x70Ad7172EF0b131A1428D0c1F66457EB041f2176",
        erc: true,
        decimalA: 18,
        decimalB: 18,
    },
];
export default pairs;
